import { Box, DashboardModule } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

import EntityFilters from '../EntityFilters'
import EntityList from '../EntityList'

import Provider from './Provider'

interface ProvidersProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
}

const Providers = (props: ProvidersProps) => {
  const { assignTemplatePagePermissionsPayload } = props

  return (
    <DashboardModule title="Providers">
      <Box flexDirection="column" padding="large">
        <EntityFilters
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityName="Providers"
        />

        <EntityList
          assignTemplatePagePermissionsPayload={assignTemplatePagePermissionsPayload}
          entityKey="providerIds"
          // @ts-expect-error TS2322
          entityListItemComponent={Provider}
        />
      </Box>
    </DashboardModule>
  )
}

export default Providers
